import React from 'react';
import CategoryItemWrapper from './CategoryItemCity.styles';

const CategoryItemCity = ({ path, classDisable, img, name, onClick }) => {
  return (
    <CategoryItemWrapper>
      {/*<a target="_blank" rel="noopener noreferrer" href={path}></a>*/}
      <div onClick={onClick}>
        <img
          src={img}
          alt={name}
          width="100%"
          className={classDisable === true ? 'disable' : ''}
        />
        <p
          className={
            classDisable === true ? 'category-name-underline' : 'category-name'
          }
        >
          {name}
        </p>
      </div>
    </CategoryItemWrapper>
  );
};

export default CategoryItemCity;
